<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_ProfitShareReset')"
    width="900px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    custom-class="details-view profit-share-dialog"
  >
    <div class="main-content">
      <el-form
        :inline="true"
        :model="initShareAmount"
        label-width="90px"
        label-position="right"
      >
        <div class="el-form-item-wrapper" style="padding-top: 5px">
          <el-form-item :label="$t('CargoMsg.Cargo_UsdProfit')">
            <el-input-number v-model="initShareAmount.usdProfit" no="usdProfit" :disabled="true" :precision="2" :controls="false" /> USD
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_NonUsdProfit')">
            <el-input-number v-model="initShareAmount.nonUsdProfit" no="nonUsdProfit" :disabled="true" :precision="2" :controls="false" /> {{ localCurrency }}
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_JobProfit')">
            <el-input-number v-model="initShareAmount.jobProfit" no="jobProfit" :disabled="true" :precision="2" :controls="false" /> {{ localCurrency }}
          </el-form-item>
        </div>
        <div class="el-form-item-wrapper" style="padding-top: 5px;padding-bottom: 10px">
          <el-form-item :label="$t('CargoMsg.Cargo_ShareMode')">
            <el-select v-model="initShareAmount.shareMode" no="shareMode" style="width:130px" @change="changeShareAmount()">
              <el-option :label="$t('CargoMsg.Cargo_ShareModeJob')" value="job" />
              <el-option :label="$t('CargoMsg.Cargo_ShareModeCurrency')" value="currency" />
            </el-select>
          </el-form-item>
        </div>
        <div class="section grid-wrapper" style="min-height: 200px;">
          <cargo-ag-grid
            v-show="showNonUsdRatioInput"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="shareBranchList"
            :auto-fit-content="false"
            style="width: 100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
          <cargo-ag-grid
            v-show="!showNonUsdRatioInput"
            :grid-options="gridOptionsJob"
            :column-defs="columnDefsJob"
            :row-data="shareBranchList"
            :auto-fit-content="false"
            style="width: 100%;"
            @gridReady="params=>{gridApiJob=params.api}"
          />
        </div>
      </el-form>
    </div>
    <div slot="footer" style="float: right">
      <el-button type="primary" no="confirm" @click="onConfirm">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      <el-button no="cancel" @click="onCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'ProfitShareDialog',
  components: { CargoAgGrid, CargoAgGridCommonInputEditor },
  props: {
    visible: { type: Boolean, required: true, default: () => false },
    jobUuid: { type: String, required: true },
    job: { type: Object, required: true },
    initShareAmount: { type: Object }, // 最新分润金额
    shareBranchList: { type: Array } // 参与分润分公司
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [],
          resizable: true,
          filter: true
        },
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        pagination: false,
        onRowClicked: this.onRowSelected
      },
      gridOptionsJob: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [],
          resizable: true,
          filter: true
        },
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        pagination: false,
        onRowClicked: this.onRowSelected
      },
      selectedItem: {}, // 当前选中
      gridParams: {},
      rowData: [],
      gridApi: null,
      gridApiJob: null,
      innerVisible: false
    }
  },
  computed: {
    // 是否显示非美金
    showNonUsdRatioInput() {
      return this.initShareAmount.shareMode !== SystemConstants.SHARE_MODE_JOB.code
    },
    columnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_SerialNo'), colId: 'serialNo', field: 'serialNo', initialWidth: 50, minWidth: 50, sortable: false, editable: false,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_ShareBranchId'), colId: 'branchId', field: 'branchId', initialWidth: 160, minWidth: 160, sortable: false, editable: false,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_UsdRatioColumn') + '-%', colId: 'usdRatio', field: 'usdRatio', initialWidth: 140, minWidth: 140, sortable: false,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0')
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              max: 100,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p),
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_UsdProfitColumn') + '-USD', colId: 'usdProfit', field: 'usdProfit', initialWidth: 140, minWidth: 140, sortable: false, editable: false,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_NonUsdRatioColumn') + '-%', colId: 'nonUsdRatio', field: 'nonUsdRatio', initialWidth: 140, minWidth: 140, sortable: false,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0')
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              max: 100,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p),
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_NonUsdProfitColumn') + '-' + this.localCurrency, colId: 'nonUsdProfit', field: 'nonUsdProfit', initialWidth: 150, minWidth: 150, sortable: false, editable: false,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          cellStyle: { textAlign: 'center' }
        }
      ]
    },
    columnDefsJob() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_SerialNo'), colId: 'serialNo', field: 'serialNo', initialWidth: 50, minWidth: 50, sortable: false, editable: false,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_ShareBranchId'), colId: 'branchId', field: 'branchId', initialWidth: 160, minWidth: 160, sortable: false, editable: false,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_UsdRatio') + '-%', colId: 'usdRatio', field: 'usdRatio', initialWidth: 140, minWidth: 140, sortable: false,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0')
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              max: 100,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p),
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_UsdProfitColumn2') + '-' + this.localCurrency, colId: 'usdProfit', field: 'usdProfit', initialWidth: 140, minWidth: 140, sortable: false, editable: false,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          cellStyle: { textAlign: 'center' }
        }
      ]
    },
    localCurrency() {
      return this.initShareAmount.currency || 'RMB'
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.$nextTick(() => {
            this.changeShareAmount()
          })
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    onRowSelected(event) {
      this.selectedItem = event.data
    },
    onConfirm() {
      this.changeShareAmount()
      let usdRatioSum = 0
      let nonUsdRatioSum = 0
      // 分润模式
      for (const item of this.shareBranchList) {
        item.shareMode = this.initShareAmount.shareMode
        item.usdProfit = this.initShareAmount.usdProfit
        item.nonUsdProfit = this.initShareAmount.nonUsdProfit
        item.jobProfit = this.initShareAmount.jobProfit
        item.currency = this.initShareAmount.currency
        item.apMaxSerialNumber = this.initShareAmount.apMaxSerialNumber
        item.officeId = this.initShareAmount.officeId
        item.usdRate = this.initShareAmount.usdRate
        item.businessDate = this.initShareAmount.businessDate
        // 比例合计
        usdRatioSum += NumberUtils.ToFixed(item.usdRatio, 0)
        usdRatioSum = NumberUtils.ToFixed(usdRatioSum, 0)
        nonUsdRatioSum += NumberUtils.ToFixed(item.nonUsdRatio, 0)
        nonUsdRatioSum = NumberUtils.ToFixed(nonUsdRatioSum, 0)
      }
      console.log('usdRatioSum', usdRatioSum)
      console.log('nonUsdRatioSum', nonUsdRatioSum)
      if (usdRatioSum > 100 || nonUsdRatioSum > 100) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ProfitShareRatioSumExceed'))
        return
      }
      this.$emit('confirm', this.shareBranchList)
    },
    onCancel() {
      this.innerVisible = false
    },
    onCellChange(params) {
      if (params.colDef.field === 'usdRatio') {
        params.data.usdRatio = params.data.usdRatio || 0
        if (params.data.usdRatio < 0) {
          params.data.usdRatio = 0
        }
        if (params.data.usdRatio > 100) {
          params.data.usdRatio = 100
        }
        const usdRatio = NumberUtils.ToFixed(params.data.usdRatio / 100, 2)
        params.node.setDataValue('usdProfit', NumberUtils.ToFixed((this.showNonUsdRatioInput ? this.initShareAmount.usdProfit : this.initShareAmount.jobProfit) * usdRatio, 2))
      } else if (params.colDef.field === 'nonUsdRatio') {
        params.data.nonUsdRatio = params.data.nonUsdRatio || 0
        if (params.data.nonUsdRatio < 0) {
          params.data.nonUsdRatio = 0
        }
        if (params.data.nonUsdRatio > 100) {
          params.data.nonUsdRatio = 100
        }
        const nonUsdRatio = NumberUtils.ToFixed(params.data.nonUsdRatio / 100, 2)
        params.node.setDataValue('nonUsdProfit', NumberUtils.ToFixed(this.initShareAmount.nonUsdProfit * nonUsdRatio, 2))
      }
    },
    changeShareAmount() {
      for (const item of this.shareBranchList) {
        item.usdRatio = item.usdRatio || 0
        const usdRatio = NumberUtils.ToFixed(item.usdRatio / 100, 2)
        item.usdProfit = NumberUtils.ToFixed((this.showNonUsdRatioInput ? this.initShareAmount.usdProfit : this.initShareAmount.jobProfit) * usdRatio, 2)
        // 非美金
        if (this.showNonUsdRatioInput) {
          item.nonUsdRatio = item.nonUsdRatio || 0
          const nonUsdRatio = NumberUtils.ToFixed(item.nonUsdRatio / 100, 2)
          item.nonUsdProfit = NumberUtils.ToFixed(this.initShareAmount.nonUsdProfit * nonUsdRatio, 2)
        } else {
          item.nonUsdRatio = 0
          item.nonUsdProfit = 0
        }
      }
      if (this.showNonUsdRatioInput) {
        this.setFocused(this.gridApi, this.selectedItem && this.selectedItem.branchId ? this.selectedItem.branchId : 0)
      } else {
        this.setFocused(this.gridApiJob, this.selectedItem && this.selectedItem.branchId ? this.selectedItem.branchId : 0)
      }
    },
    // 默认选中
    setFocused(gridApi, branchId) {
      if (gridApi) {
        gridApi.refreshCells({ force: true })
        if (branchId) {
          const nodes = gridApi.getModel().rowsToDisplay
          for (const item of nodes) {
            if (!item.data) {
              continue
            }
            if (item.data.branchId === this.selectedItem.branchId) {
              item.setSelected(true)
              item.setData(item.data)
              gridApi.ensureIndexVisible(item.rowIndex)
              break
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.profit-share-dialog {
  .el-dialog__body {
    padding: 5px !important;
    .el-form-item {
      margin-bottom: 0!important;
    }
  }
}
</style>
